module.exports = __webpack_public_path__ + "img/Game_49220.6af618b9.png";